import * as Yup from 'yup';

const ACCOUNT_INFO_SCHEMA = Yup.object().shape({
	password1: Yup.string().required('This field is required'),
	password2: Yup.string()
		.oneOf([Yup.ref('password1'), null], 'Passwords do not match!')
		.required('This field is required')
});

export default ACCOUNT_INFO_SCHEMA;
